import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { PaytrieAPI } from '@paytrie/client'
import { StatusBadge } from '@/components/StatusBadge'
import { getOtcTone, toOtcStatusLabel } from './otcRequestUtils'

type OtcStatusBadgeProps = {
  status: PaytrieAPI.OtcRequestStatus
  cancelledAt?: string | null
  testId?: string
}

export const OtcStatusBadge = memo(function OtcStatusBadge({
  status,
  cancelledAt,
  testId,
}: OtcStatusBadgeProps) {
  const { t } = useTranslation()
  const isClosed = status === 'cancelled' && !cancelledAt
  const label = isClosed
    ? t('otcRequestStatus.closedBadge')
    : t(`dashboardOtcRequests.status.${status}`, {
        defaultValue: toOtcStatusLabel(status),
      })

  return (
    <StatusBadge tone={getOtcTone(status)} testId={testId}>
      {label}
    </StatusBadge>
  )
})
